import React, {useState} from 'react'; 
import shortid from 'shortid'
import Error from './Error'
import PropTypes from 'prop-types';

const Formulario = ({setGasto, setCrearGasto}) => {

    const [nombre, setNombre] = useState('')
    const [cantidad, setCantidad] = useState(0)
    const [error, setError] = useState(false)

    const agregarGasto= e =>{
        e.preventDefault();

        if(cantidad<1 || isNaN(cantidad) || nombre.trim() === '' )
        {
            setError(true);
            return;
        }
        setError(false);
        const gasto = {
            nombre,
            cantidad,
            id: shortid.generate()
        }
        setGasto(gasto);
        setCrearGasto(true);
        setNombre('');
        setCantidad(0);
    }

    return ( 
        <form
            onSubmit={agregarGasto}
        >
            <h2>Add your expenses</h2>
            {error ? <Error mensaje="Wrong values"/> : null}
            <div className="campo">
                <label>expense name</label>
                <input
                    type="text"
                    className="u-full-width"
                    placeholder="Ex. Transport"
                    value={nombre}
                    onChange={e=>setNombre(e.target.value)}
                />
            </div>
            <div className="campo">
                <label>expense value</label>
                <input
                    type="number"
                    className="u-full-width"
                    placeholder="Ex. 300"
                    value={cantidad}
                    onChange={e=>setCantidad(parseInt(e.target.value))}
                />
            </div>

            <button
                type="submit"
                className="button-primary u-full-width"
            >Add</button>
        </form>

     );
}

Formulario.propTypes = {
    setGasto: PropTypes.func.isRequired,
    setCrearGasto: PropTypes.func.isRequired
}
 
export default Formulario;